export default "__VITE_ASSET__0fe86543__"